module.exports = __webpack_public_path__ + "media/images/default-150x150-ee05747c1a631a78ac38b1ce8689ee63.png";